import React from 'react';
import { SList } from './styled';
import IDHelpers from '../../../../core/helpers/IDHelper';
import svgStar from './assets/star.svg';

const ListRecursiveItem = ({
  item
}: {
  item: { title: string; text: string; items: any[] };
}) => (
  <li>
    {item.title && <h3>{item.title}</h3>}
    {item.text && <p>{item.text}</p>}
    {item.items && item.items.length > 0 && (
      <ul>
        {item.items.map((subItem) => (
          <ListRecursiveItem key={IDHelpers.generateID()} item={subItem} />
        ))}
      </ul>
    )}
  </li>
);

const ListRecursive = ({ items }: { items: any[] }) => (
  <ul>
    {items.map((item) => (
      <ListRecursiveItem key={IDHelpers.generateID()} item={item} />
    ))}
  </ul>
);

export const List = () => {
  const temp = [
    {
      title:
        'Para que tu foto sea válida, debe tener las siguientes especificaciones:',
      items: [
        {
          text: 'Formato de archivo: jpg.'
        },
        {
          text: 'Tamaño de foto: 240 x 288 pixeles.'
        },
        {
          text: 'Resolución de la foto: 300 dpi.'
        },
        {
          text: 'Foto a color con fondo blanco.'
        },
        {
          text: 'Peso del archivo: 30 a 50 kb.'
        }
      ]
    },
    {
      title: '¿Cómo debo tomarme la foto?',
      items: [
        {
          text: 'Debo tomarme la foto sin lentes, ni gorra, ni piercings, ni estar vestido completamente de blanco, ni accesorios que cubran el cuello ni parte del rostro.'
        },
        {
          text: 'No se aceptan selfies.'
        },
        {
          text: 'La foto debe enfocarse en el rostro del estudiante a partir de los hombros (tipo DNI).'
        },
        {
          text: 'Preferentemente utilizar vestimenta formal (mujer: blusa y sastre; varón: camisa, corbata y saco). No prendas blancas, escotadas ni que descubran los hombros.'
        }
      ]
    }
  ];

  return (
    <SList>
      <div>
        <div>
          <img src={svgStar} alt="svg" />
        </div>
        <p>
          La foto registrada o actualizada sirve para el trámite de emisión de
          carné universitario, certificado de estudios y carné digital de
          UTP+app.
        </p>
      </div>
      <ListRecursive items={temp} />
      <div>
        Tu fotografía deberá cumplir con todas especificaciones mencionadas,
        dado que pasará también por un filtro de revisión de Sunedu.
      </div>
    </SList>
  );
};
